import { FblTeamStatistics } from 'components/sports/fbl/views/FblTeamStatistics';
import { isParalympic, CompetitionFromStore } from "helpers/utils";

const RenderPeriods = ({ data, statsTOT }) => {
    return (
        <FblTeamStatistics data={data?.results} stats={statsTOT} />
    )
}

function FblTeamStats({ data }) {
    const competition = CompetitionFromStore();
    let statsTOT;
    if (isParalympic(competition)) {
        statsTOT = [
            { code: 'TOUT' },
            { code: 'POSSESS' },
            { code: 'RC' },
            { code: 'YRC' },
            { code: 'YC' },
            { code: 'OG' },
            { code: '2PTY', component: 'type12' },
            { code: 'PTY', component: 'type12' },
            { code: 'FRK', header: 'FRK_IND', paint: 'FKI' },
            { code: 'FRK', header: 'FRK', paint: 'FKD' },
            { code: 'CRN' },
            { code: 'FOC' },
            { code: 'SHOT', header: 'SHOT_BLC', paint: 'BLC' },
            { code: 'SHOT', header: 'SHOT_TAR' },
            { code: 'SHOT', component: 'type9' }
        ]
    } else {
        statsTOT = [
            { code: 'POSSESS' },
            { code: 'RC' },
            { code: 'YRC' },
            { code: 'YC' },
            { code: 'OG' },
            { code: 'PTY', component: 'type12' },
            { code: 'FRK', header: 'FRK_IND', paint: 'FKI' },
            { code: 'FRK', header: 'FRK', paint: 'FKD' },
            { code: 'CRN' },
            { code: 'FOC' },
            { code: 'SHOT', header: 'SHOT_BLC', paint: 'BLC' },
            { code: 'SHOT', header: 'SHOT_TAR' },
            { code: 'SHOT', component: 'type9' }
        ]
    }

    return (
        <><RenderPeriods data={data} statsTOT={statsTOT} /></>
    );
}

export default FblTeamStats;